module.exports = __webpack_public_path__ + "img/google.abb8322b.png";